module.exports = __webpack_public_path__ + "static/media/ArthroCure.e36f85b4.pptx";